import actionTypes from './actionTypes'

const googleDriveActions = {
	initializeGoogleSlidesSuccess(response) {
		return {
			type: actionTypes.GOOGLE_SLIDES_INITIALIZE_SUCCESS,
			response,
		}
	},
	initializeGoogleSlidesFailed(error) {
		return {
			type: actionTypes.GOOGLE_SLIDES_INITIALIZE_UNKNOWN,
			error,
		}
	},
	createGoogleSlidesActivity(id) {
		return {
			type: actionTypes.GOOGLE_SLIDES_ACTIVITY_CREATE,
			id,
		}
	},
	editGoogleSlidesActivity() {
		return {
			type: actionTypes.GOOGLE_SLIDES_ACTIVITY_EDIT,
		}
	},
	saveAndGoToNearpod() {
		return {
			type: actionTypes.GOOGLE_SLIDES_SAVE_AND_GO_TO_NEARPOD,
		}
	},
	saveGoogleSlidesActivitySuccess(icon, slideExternalId, slideTypeId) {
		return {
			type: actionTypes.GOOGLE_SLIDES_ACTIVITY_SAVED,
			icon,
			slideExternalId,
			slideTypeId,
		}
	},
	googleSlidesActivitySaveFinished(data) {
		return {
			type: actionTypes.GOOGLE_SLIDES_ACTIVITY_SAVED_FINISHED,
			...data.payload,
		}
	},
	saveGoogleSlidesActivityFailed() {
		return {
			type: actionTypes.GOOGLE_SLIDES_ACTIVITY_SAVE_FAILED,
		}
	},
	googleSlidesExternalIdObtained(data) {
		return {
			type: data.action_type,
			payload: data.payload,
		}
	},
	googleSlidesActivityEditExternalIdObtained(data) {
		return {
			type: data.action_type,
			payload: data.payload,
		}
	},
	googleSlidesEditLesson(lessonData) {
		return {
			type: actionTypes.GOOGLE_SLIDES_EDIT_LESSON,
			lessonData,
		}
	},
	googleSlidesEditLessonSuccess(lessonData, payload) {
		return {
			type: actionTypes.GOOGLE_SLIDES_EDIT_LESSON_SUCCESS,
			lessonData,
			response: payload,
		}
	},
	goToMyLibrary() {
		return {
			type: actionTypes.GOOGLE_SLIDES_GO_TO_MY_LIBRARY,
		}
	},
	getExternalSlideDataForEditSuccess(data) {
		return {
			type: actionTypes.GOOGLE_SLIDES_GET_EXTERNAL_SLIDE_DATA_FOR_EDIT_SUCCESS,
			payload: data.payload,
		}
	},
	getExternalSlideDataForEditFailed(serverError) {
		return {
			type: actionTypes.GOOGLE_SLIDES_GET_EXTERNAL_SLIDE_DATA_FOR_EDIT_FAILED,
			serverError,
		}
	},
	learnMore(url, size, title) {
		return {
			type: actionTypes.GOOGLE_SLIDES_LEARN_MORE,
			url,
			size,
			title,
		}
	},
	savePresentationFailedConfirmed() {
		return {
			type: actionTypes.GOOGLE_SLIDES_SAVE_PRESENTATION_FAILED_CONFIRMED,
		}
	},
	savePresentationProgressiveFailed(error, presentationExternalId, entityUID) {
		return {
			type: actionTypes.GOOGLE_SLIDES_SAVE_PRESENTATION_PROGRESSIVE_FAILED,
			error,
			presentationExternalId,
			entityUID,
		}
	},
	startSavePresentationProgressive() {
		return {
			type: actionTypes.GOOGLE_SLIDES_SAVE_PRESENTATION_PROGRESSIVE_START,
		}
	},
	startSavePresentationProgressiveUpdate(currentSlide, totalSlides, entityUID) {
		return {
			type: actionTypes.GOOGLE_SLIDES_SAVE_PRESENTATION_PROGRESSIVE_UPDATE,
			currentSlide,
			totalSlides,
			entityUID,
		}
	},
	startSavePresentationProgressiveFailed(error, entity) {
		return {
			type: actionTypes.GOOGLE_SLIDES_SAVE_PRESENTATION_PROGRESSIVE_START_FAILED,
			error,
			entity,
		}
	},
	processSlidesFailed(error, presentationExternalId, entityUID) {
		return {
			type: actionTypes.GOOGLE_SLIDES_PROCESS_SLIDES_FAILED,
			error,
			presentationExternalId,
			entityUID,
		}
	},
	googleSlidesCloseModal() {
		return {
			type: actionTypes.GOOGLE_SLIDES_CLOSE_MODAL,
		}
	},
	googleAuthorizeUserFailed(error) {
		return {
			type: actionTypes.GOOGLE_SLIDES_AUTHORIZE_USER_FAILED,
			error,
		}
	},
	googleAuthorizeUserSuccess() {
		return {
			type: actionTypes.GOOGLE_SLIDES_AUTHORIZE_USER_SUCCESS,
		}
	},
	googleAuthorizeUserCancel(error) {
		return {
			type: actionTypes.GOOGLE_SLIDES_AUTHORIZE_USER_CANCEL,
			error,
		}
	},
	googleCreateLessonAuthorizeSuccess(isInIframe) {
		return {
			type: actionTypes.GOOGLE_SLIDES_CREATE_AUTHORIZE_SUCCESS,
			isInIframe,
		}
	},
	LMSOpenGoogleConfirmed(redirectUrl) {
		return {
			type: actionTypes.GOOGLE_SLIDES_LMS_OPEN_GOOGLE_CONFIRMED,
			redirectUrl,
		}
	},
	LMSRefreshConfirmed() {
		return {
			type: actionTypes.GOOGLE_SLIDES_LMS_REFRESH_CONFIRMED,
		}
	},
	googleCurrentSlideChanged(slideExternalId) {
		return {
			type: actionTypes.GOOGLE_SLIDES_CURRENT_SLIDE_CHANGED,
			slideExternalId,
		}
	},
	googleSlidesGetSlideTypeSuccess(currentSlide) {
		return {
			type: actionTypes.GOOGLE_SLIDES_GET_SLIDE_TYPE_SUCCESS,
			currentSlide,
		}
	},
	googleSlidesChangeCurrentSlideIndex(currentSlideIndex) {
		return {
			type: actionTypes.GOOGLE_SLIDES_CHANGE_CURRENT_SLIDE_INDEX,
			currentSlideIndex,
		}
	},
	googleSlidesConvertToDrawIt() {
		return {
			type: actionTypes.GOOGLE_SLIDES_CONVERT_TO_DRAW_IT,
		}
	},
	googleSlidesConvertToDrawItGetThumbnailSuccess(activityData) {
		return {
			type: actionTypes.GOOGLE_SLIDES_CONVERT_TO_DRAW_IT_GET_THUMBNAIL_SUCCESS,
			activityData,
		}
	},
	googleSlidesConvertToDrawItFailed() {
		return {
			type: actionTypes.GOOGLE_SLIDES_CONVERT_TO_DRAW_IT_FAILED,
		}
	},
	googleSlidesScreenshotObtained(screenshot, slideExternalId) {
		return {
			type: actionTypes.GOOGLE_SLIDES_SCREENSHOT_OBTAINED,
			screenshot,
			slideExternalId,
		}
	},
	googleSlidesScreenshotProccessing() {
		return {
			type: actionTypes.GOOGLE_SLIDES_SCREENSHOT_PROCCESSING,
		}
	},
}

export default googleDriveActions
